export default __webpack_public_path__ + "static/media/nl.7ff6848e.svg";